import { FC } from 'react';
import { noop } from 'lodash';
import classNames from 'classnames';
import { useContextSelector } from 'use-context-selector';

import { ActionSheetMenuContext } from '../ActionSheetMenu.context';
import { Button, ButtonProps } from '../../../Button';

import styles from './ActionSheetMenuButton.module.scss';

export const ActionSheetMenuButton: FC<ButtonProps> = ({
  children,
  onClick = noop,
  className,
  ...props
}) => {
  const dismiss = useContextSelector(
    ActionSheetMenuContext,
    ({ dismiss }) => dismiss
  );

  const handleOnClick = () => {
    onClick();
    dismiss();
  };

  return (
    <Button
      className={classNames(styles.button, className)}
      onClick={handleOnClick}
      {...props}
    >
      {children}
    </Button>
  );
};
